import { ISelectItem } from '@/interfaces/Select'

export interface ITableConfig {
    headless?: boolean;
    useQuery?: boolean;
    usePagination?: boolean;
    stickyScrollbar?: boolean;
    disablePreloader?: boolean;
    useSubrow?: boolean;
    minHeight?: string;
    rowClass?: string;
    maxHeight?: string;
    debounceTime?: number;
    rowClick?: Function;
    fetchFunction?: Function;
    columns: ITableColumn[];
    clearFilterBtn?: ITableHeadClearBtn;
}

export interface ITableHeadClearBtn {
    wrapperClass?: string;
    wrapperStyle?: string;
    class?: string;
    style?: string;
}

export interface ITableColumn {
    minWidth?: string;
    maxWidth?: string;
    headClass?: string;
    width?: number;
    class?: string;
    key?: string;
    label?: string;
    searchKey?: string;
    hasSearch?: boolean;
    hasSort?: boolean;
    type?: ETableColumnType;
    // inputType?: string;
    options?: ISelectItem[] | Function;
}

export enum ETableColumnType {
    default = 'default',
    numberRange = 'numberRange',
    date = 'date',
    dateRange = 'dateRange',
    select = 'select',
    multiselect = 'multiselect',
    actions = 'actions',
    secondaryActions = 'secondaryActions',
    char = 'char',
    number = 'number'
}
